export const helpTr = {
  open: 'Yardımı aç',
  title: 'Yardım',
  search: 'Yardımda ara',
  noResults: 'Eşleşen yardım makalesi yok.',
  loading: 'Yardım yükleniyor…',
  error: 'Yardım yüklenemedi.',
  retry: 'Yeniden dene',
  fallback: 'Bu makale henüz dilinizde mevcut değil.',
  allTopics: 'Tüm konular',
  related: 'İlgili konular',
  empty: 'Rolünüz için şu anda yardım makalesi yok. İçeriği yeniden yükleyebilirsiniz.',
  translationStatus:
    '{{current}}/{{total}} makale güncel · {{locales}} dil · {{fallback}} yedek · {{stale}} eski',
  categories: {
    general: 'Genel',
    accounting: 'Muhasebe',
    documents: 'Belgeler',
    finance: 'Finans',
    'getting-started': 'Başlarken',
    manufacturing: 'Üretim',
    marketing: 'Pazarlama',
    partners: 'İş ortakları',
    plm: 'Ürün geliştirme',
    portal: 'Müşteri portalı',
    products: 'Ürünler',
    questionnaires: 'Anketler',
    sales: 'Satış',
    security: 'Güvenlik',
    settings: 'Ayarlar',
  },
} as const;
